module.exports = __webpack_public_path__ + "static/geometric-bg-03-8ab12c09c69b4c5033897fc2eaad14da.svg";